import { render, staticRenderFns } from "./problem-management.vue?vue&type=template&id=36428100&scoped=true"
import script from "./problem-management.vue?vue&type=script&lang=js"
export * from "./problem-management.vue?vue&type=script&lang=js"
import style0 from "./problem-management.vue?vue&type=style&index=0&id=36428100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36428100",
  null
  
)

export default component.exports